































































































































import {defineComponent} from 'vue'
import {TmsGaDto} from "../../ob1/dto/TmsGaDto";

export default defineComponent({
    name: "ModalDialog",
    props: {
        // id de la modal
        id: {
            type: String,
            required: true
        },
        actionLabel: {
            type: String,
            required: true
        },
        modalCloseLabel: {
            type: String,
            required: false,
            default: "Fermer"
        },
        modalTitle: {
            type: String,
            required: false,
            default: null
        },
        modalContent: {
            type: String,
            required: false,
            default: null
        },
        isModalButtonClose: {
            type: Boolean,
            required: false,
            default: true
        },
        modalButtonLabel: {
            type: String,
            required: true
        },
        isModalButtonPrimary: {
            type: Boolean,
            required: false,
            default: true
        },
        isActionButton: {
            type: Boolean,
            required: false,
            default: true
        },
        imageUrl: {
            type: String,
            required: false,
            default: null
        },
        imageAlt: {
            type: String,
            required: false,
            default: null
        },
        alertHtmlContent: {
            type: String,
            required: false,
            default: null
        },
        tmsCategory: {
            type: String,
            required: false,
            default: ""
        },
        tmsLabel: {
            type: String,
            required: false,
            default: "ouverture-popin"
        }
    },
    computed: {
        labelId() {
            return this.id + '-label'
        },
        actionTms(): TmsGaDto {
            return {
                category: this.tmsCategory,
                action: toBroadbandTmsFormat(this.actionLabel),
                label: toBroadbandTmsFormat(this.tmsLabel)
            }
        }
    }
})
